var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4792 0H6.74698C3.16945 0 0.269287 2.90016 0.269287 6.47769V22.0777C0.269287 25.6553 3.16945 28.5554 6.74698 28.5554H22.4792C26.0568 28.5554 28.9569 25.6553 28.9569 22.0777V6.47769C28.9569 2.90016 26.0568 0 22.4792 0Z",
    fill: "#11998E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7539 11.0684H15.3785V12.9264H15.4312C15.936 12.0209 17.1704 11.0684 19.011 11.0684C22.8384 11.0684 23.5461 13.4503 23.5461 16.5487V23.0998H19.7663L19.7657 17.2654C19.7657 15.9313 19.7382 14.2145 17.8001 14.2145C15.8324 14.2145 15.5303 15.6663 15.5303 17.1684V23.0998H11.7539V11.0684ZM9.61184 7.42136C9.61184 8.50611 8.73104 9.38691 7.64629 9.38691C6.56098 9.38691 5.68018 8.50611 5.68018 7.42136C5.68018 6.33605 6.56098 5.45581 7.64629 5.45581C8.73104 5.45581 9.61184 6.33605 9.61184 7.42136ZM5.68018 11.0684H9.61184V23.0998H5.68018V11.0684Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6876,
    height: 28.5554,
    fill: "white",
    transform: "translate(0.269287)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d0ce6ad77461bc891e46fe4e8040fe9e.svg";
export { ForwardRef as ReactComponent };